import React, { memo } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import * as moment from "moment";

import { getVehicleIcon } from "../../../../../../includes/util";

const useStyles = makeStyles(() => ({
  tableCell: {
    cursor: "pointer",
  },
  cellPaddingFirstStyle: {
    padding: "16px 1px 16px 10px",
    //backgroundColor : "#ffddcc"
  },
  cellPaddingStyle: {
    padding: "16px 0px 16px 0px",
    //backgroundColor : "#ffddcc"
  },
}));

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },

  },
}))(TableRow);

const VehicleListGridTableItem = ({ item, selected, clickedVehicle }) => {



  const classes = useStyles();



  const onClickVehicle = () => {
    clickedVehicle(item);
  };
  return (
    <React.Fragment>
      <StyledTableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={item.StationId}
        selected={selected}
        className={classes.tableCell}
      >
        <TableCell align="left" className={classes.cellPaddingFirstStyle}>
          <div
            className="s-icons"
            onClick={onClickVehicle}
          >
            <span className="vehicle-icon">
              <img
                src={getVehicleIcon(item.RucMonkeyVehicleTypeId)}
                alt="vehicle"
              />
            </span>

          </div>
        </TableCell>
        <TableCell
          onClick={onClickVehicle}
          align="left"
          className={classes.cellPaddingStyle}
        >
          {item.VehiclePlate}
        </TableCell>
        <TableCell
          onClick={onClickVehicle}
          align="left"
          className={classes.cellPaddingStyle}
        >
          {item.VehicleCode}
        </TableCell>
        <TableCell
          onClick={onClickVehicle}
          align="left"
          className={classes.cellPaddingStyle}
        >
          {item.FleetName}
        </TableCell>


        <TableCell
          onClick={onClickVehicle}
          align="left"
          className={classes.cellPaddingStyle}
        >
          {moment(item.OdometerReadingTimestamp).format("DD/MM/YYYY HH:mm:ss")}

        </TableCell>
        <TableCell
          onClick={onClickVehicle}
          align="left"
          className={classes.cellPaddingStyle}
        >
          {item.LocationDescription}
        </TableCell>


      </StyledTableRow>
    </React.Fragment>
  );
};

export default memo(VehicleListGridTableItem);
